import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router';
import { generateTokens, validateTokens } from '../api/apiToken';
import { getAllCountries, getDistricts, getDTO } from '../api/formMethods';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    comunicanteId: null,
    comunicanteContacto: null,
    isTokenValid: false,
    objDTO: null,
    countries: [],
    statesBrasil: []
  },
  mutations: {
    setLocalVistoria(state, payload) {
      state.objDTO.Vistoria.VistoriaLocal.Morada = payload.Morada;
    },
    setRegister(state, payload) {
      state.comunicanteId = payload;
    },
    setValidateTokens(state, payload) {
      state.isTokenValid = payload;
    },
    setObjDTO(state, payload) {
      state.objDTO = payload;
      state.objDTO.ProcessoOrigemId = 25;
    },
    setComunicanteContacto(state, payload) {
      state.comunicanteContacto = payload;
    },
    setCountries(state, payload) {
      state.countries = payload;
    },
    setStatesBrasil(state, payload) {
      state.statesBrasil = payload;
    }
  },
  actions: {
    async register({ commit }, payload) {
      const res = await generateTokens(payload);
      commit('setRegister', res);
      commit('setComunicanteContacto', payload);
    },
    async validate({ commit }, payload) {
      const res = await validateTokens(payload);
      commit('setValidateTokens', res);
      if (res) {
        router.push('/info');
      }
      return res;
    },
    async getDTO({ commit }) {
      const res = await getDTO();
      commit('setObjDTO', res);
    },
    async getOrSetCountries({ commit, state }) {
      if (state.countries.length === 0) {
        const res = await getAllCountries();
        commit('setCountries', res);
      } else {
        return state.countries;
      }
    },
    async getOrSetStatesBrasil({ commit, state }) {
      if (state.statesBrasil.length === 0) {
        const res = await getDistricts();
        commit('setStatesBrasil', res);
      } else {
        return state.statesBrasil;
      }
    }
  },
  modules: {},
  getters: {
    getComunicateId: state => {
      return state.comunicanteId;
    },
    isAuthenticated: state => state.comunicanteId !== null && state.isTokenValid,
    getObjDTO: state => state.objDTO,
    getComunicanteContacto: state => state.comunicanteContacto,
    getCountries: state => state.countries,
    getStatesBrasil: state => state.statesBrasil
  }
});
